/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

/* eslint-disable sort-keys */
export default {
  appId: 'hummingbird',
  distributionList: ['ayarlaga@adobe.com', 'upant@adobe.com', 'glo65276@adobe.com', 'glo80368@adobe.com', 'anushree@adobe.com'],
  name: 'Project Hummingbird',
  access: [],
  path: '/hummingbird',
  sandbox: {
    history: 'HISTORY',
    sources: {
      dev: 'https://localhost.corp.adobe.com:3000'
    }
  },
  sideNav: {
    dev: '',
    qa: '',
    stage: '',
    prod: ''
  },
  spaAppId: 'Project-Hummingbird-designer-ui',
  serviceCode: ''
};
